import React, { Component, useEffect, useState } from 'react'

import { makeStyles } from '@material-ui/core/styles'

import Alert from '@material-ui/lab/Alert'

import { connect } from 'react-redux'
import { postEnrollmentsData, getSISStatus } from '../../actions/'
import Typography from '@material-ui/core/Typography'
import LinearProgress from '@material-ui/core/LinearProgress'
import Button from '@material-ui/core/Button'

import { getSISImportStatus } from '../../services/saga'

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200
  }
}))

const StepThree = (props) => {
  const classes = useStyles()

  const [seconds, setSeconds] = useState(0)

  const [textStatus, setTextStatus] = useState('CSV File uploading..')
  const { csvImportedResult } = props
  const [fileUploaded, setFileUploaded] = useState(false)
  const [progress, setProgress] = useState(10)
  const [sisImportID, setSisImportID] = useState(0)

  const [importedItemCounts, setImportedItemCounts] = useState(0)

  const [scvErrors, setCsvErrors] = useState([])

  const [errorAttachment, setErrorAttachment] = useState('')

  useEffect(() => {
    const interval = setInterval(async () => {
      if (fileUploaded && progress !== 100 && progress !== 0) {
        const sisStatus = await getSISImportStatus(sisImportID)

        let textStatus = ''
        let completed = 0

        if (sisStatus.workflow_state == 'importing') {
          textStatus = 'The request is currently processing.'
          completed = 70
        }

        if (sisStatus.workflow_state == 'imported') {
          textStatus =
            'The import is complete and all records were successfully imported.'
          completed = 100

          setImportedItemCounts(sisStatus.data.counts)
        }

        if (sisStatus.workflow_state == 'imported_with_messages') {
          textStatus = 'CSV error'
          completed = 0

          setCsvErrors(sisStatus.processing_warnings)
          setErrorAttachment(sisStatus.errors_attachment.url)
        }

        setProgress(completed)
        setTextStatus(textStatus)
      }
    }, 2000)
    return () => clearInterval(interval)
  }, [fileUploaded, sisImportID, progress])

  useEffect(() => {
    if (!fileUploaded && csvImportedResult !== null) {
      let json = JSON.parse(csvImportedResult)

      if (json.workflow_state === 'created') {
        setSisImportID(json.id)
        setFileUploaded(true)
        setProgress(20)
        setTextStatus('The request has been created')
      }
    }
  }, [csvImportedResult])

  return (
    <React.Fragment>
      <Typography variant='subtitle1'>{textStatus}</Typography>

      <LinearProgress variant='determinate' value={progress} />

      {progress === 0 ? (
        <>
          <Alert severity='error'>
            {scvErrors.join(' - ')}

            <a href={errorAttachment} target='_blank'>
              {' '}
              Download Error Attachment{' '}
            </a>
          </Alert>

          <Button
            style={{
              marginTop: '30px',
              marginBottom: '30px'
            }}
            variant='outlined'
            size='large'
            color='primary'
            onClick={() => window.location.reload(false)}
          >
            Back to Home
          </Button>
        </>
      ) : null}

      {progress == 100 ? (
        <ul>
          <li>
            Imported Items
            <ul>
              <li>Accounts: {importedItemCounts['accounts']}</li>
              <li>Terms: {importedItemCounts['terms']}</li>
              <li>Courses: {importedItemCounts['courses']}</li>
              <li>Sections: {importedItemCounts['sections']}</li>
              <li>Users: {importedItemCounts['users']}</li>
              <li>Logins: {importedItemCounts['logins']}</li>
              <li>Enrolments: {importedItemCounts['enrollments']}</li>
              <li>Crosslists: {importedItemCounts['xlists']}</li>
              <li>Admins: {importedItemCounts['admins']}</li>
              <li>
                Group categories: {importedItemCounts['group_categories']}
              </li>
              <li>Groups: {importedItemCounts['groups']}</li>
              <li>
                Group Enrolments: {importedItemCounts['group_memberships']}
              </li>
              <li>User observers: {importedItemCounts['user_observers']}</li>
              <li>Change SIS IDs: {importedItemCounts['change_sis_ids']}</li>
            </ul>
          </li>
        </ul>
      ) : null}

      {progress == 100 ? (
        <div>
          {' '}
          <Button
            style={{
              marginTop: '30px',
              marginBottom: '30px'
            }}
            variant='outlined'
            size='large'
            color='primary'
            onClick={() => window.location.reload(false)}
          >
            Back to Home
          </Button>{' '}
        </div>
      ) : (
        ''
      )}
    </React.Fragment>
  )
}

function mapStateToProps(state) {
  return {
    csvImportedResult: state.Main.csvImportedResult
  }
}

export default connect(mapStateToProps, {})(StepThree)
